/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios'

const HTTPConverter = {
  fromResponse: (response: AxiosResponse<any, any>) => {
    const { data } = response
    if (!data) {
      return
    }

    let contentType
    if (response.headers.getContentType && typeof response.headers.getContentType === 'function') {
      contentType = response.headers.getContentType()?.toLocaleString().split(';')[0]
    }

    if (contentType === 'application/json') {
      // return JSON.parse(data)
    }

    return data
  }
}

export default HTTPConverter
